import { Typography } from '@mui/material';

export default function Badge({
  type,
  label
}: {
  label: string | undefined;
  type: 'success' | 'failed' | 'processing';
}) {
  const colors = {
    success: '#84d4b9',
    failed: '#d08aa1',
    processing: '#819bb5'
  };
  return (
    <Typography
      sx={{
        width: 'max-content',
        borderRadius: '20px',
        padding: '3px 20px',
        background: colors[type],
        color: '#fff'
      }}>
      {label}
    </Typography>
  );
}
